module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26.02 0C9.95 0 1.84 23.914.288 29.04.126 29.568 0 30.224 0 30.5v.5a1 1 0 0 0 2 0v-1c2-3.582 4.706-9.544 8.546-12.032A3.994 3.994 0 0 0 14.016 20a3.99 3.99 0 0 0 1.956-.53 3.995 3.995 0 0 0 1.454-1.398c.02-.036.038-.074.06-.112.134-.238.242-.488.326-.752.026-.076.052-.15.07-.228.082-.314.138-.64.138-.98 0-.202-.032-.394-.058-.586A3.963 3.963 0 0 0 20.02 16a4 4 0 0 0 4-4c0-.128-.026-.252-.04-.378.642.23 1.32.378 2.04.378a6 6 0 1 0 0-12z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/feather-2.js
// module id = 1145
// module chunks = 14